import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '@/router'

import axiosSettings from '../axios.settings'

import config from '@/../config'
import modules from './modules'

Vue.use(Vuex)
// flatten modules
let _modules = Object.keys(modules).reduce(function (r, k) {
    return r.concat(modules[k]);
}, []);

let helpers = {
	actions: [],
	mutations: [],
	state: []
}
_modules.forEach((module, index) => {
	Object.keys(module).forEach((k, r) => {
		if(module[k]) Object.keys(module[k]).forEach((item, index) => {
			helpers[k][item] = module[k][item]
		})
	})
})


export const store = new Vuex.Store({
  strict: true,
  modules
  // getters,

})



// WEBPACK FOOTER //
// ./src/store/index.js